<template>
	<div
		class="steps__step"
		:class="( is_completed_step ) ? ' steps__step--completed' : ( is_current_step ) ? ' steps__step--active' : null"
	>
		<div class="steps__step-number">
			{{ step.step_number }}
		</div>
		<div class="steps__step-title-wrapper">
			<h2 class="steps__step-title">
				{{ step.title }}
			</h2>
			<template v-if="is_completed_step">
				<ul class="steps__step-summary">
					<li v-if="selected_client">
						Client company:
						<span>{{ selected_client.label }}</span>
					</li>
					<li v-if="selected_key_client_contacts.length">
						Key client contact:
						<span>
							<template
								v-for="item, index in selected_key_client_contacts"
								:key="'key-client-contacts-' + index"
							>
								{{ item.label + ( index < selected_key_client_contacts.length - 1 ? ', ' : '' ) }}
							</template>
						</span>
					</li>
					<li v-if="selected_client_billing_contacts.length">
						Client billing contact:
						<span>
							<template
								v-for="item, index in selected_client_billing_contacts"
								:key="'client-billing-contacts-' + index"
							>
								{{ item.label + ( index < selected_client_billing_contacts.length - 1 ? ', ' : '' ) }}
							</template>
						</span>
					</li>
					<li v-if="selected_clients.length">
						Client contacts:
						<span>
							<template
								v-for="item, index in selected_clients"
								:key="'key-client-contacts-' + index"
							>
								{{ item.label + ( index < selected_clients.length - 1 ? ', ' : '' ) }}
							</template>
						</span>
					</li>
				</ul>
			</template>
		</div>
		<button
			v-if="is_completed_step"
			class="button button--smaller"
			type="button"
			@click="setActiveStep( step.step_number )"
		>
			Edit
		</button>
		<template v-else-if="is_current_step">
			<ClientInformationFormComponent
				:step-title="step.title"
			/>
		</template>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { computed, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import ClientInformationFormComponent from './ClientInformationFormComponent';

const new_project_store = useNewProjectStore();

const {
	setActiveStep
} = new_project_store;

const {
	selected_client,
	selected_key_client_contacts,
	selected_client_billing_contacts,
	selected_clients
} = storeToRefs( new_project_store );

const props = defineProps( {
	step: {
		required: true,
		type: Object
	},
	activeStepNumber: {
		required: true,
		type: Number
	}
} );

const is_current_step = computed( () => {
	return props.step.step_number === props.activeStepNumber;
} );

const is_completed_step = computed( () => {
	return props.step.step_number < props.activeStepNumber;
} );

</script>
